import React from 'react';
import {StyledIconWrapper} from './StyledIconWrapper';

const IconWrapper = ({
  children,
  color,
  size = 24,
  ...rest
}) => {

  return (
    <StyledIconWrapper color={color} size={24} {...rest}>
      {children}
    </StyledIconWrapper>
  );
}

export default IconWrapper;
